export default __webpack_public_path__ + "static/overlay-fda5cd94216f7ef0de64dcbc2f252720.jpeg";